import { lazy } from "react";
import { getRoute } from "util/react";

export const MessagesRoute = getRoute(
  { fullPath: "/:locale?/messages" },
  "messages",
  lazy(() => import("./index")),
  null,
);

export const MessageRoute = getRoute(
  { fullPath: "/:locale?/messages/:id" },
  "messages/:id",
  lazy(() => import("./message")),
  null,
);

const MessageListRoute = (
  <>
    {MessagesRoute}
    {MessageRoute}
  </>
);

export default MessageListRoute;
